import $ from "jquery"

/**
 * Scripts for header fixed position
 */
window.onscroll = function() {
    fixedHeader();
};

const header = document.querySelector('.header')

function fixedHeader() {
    if (window.pageYOffset > 0) {
        header.classList.add('header--fixed')
    } else {
        header.classList.remove('header--fixed')
    }
}

// Close navbar on mobile when user clicks nav item link
var primaryMenuItem = $('#menu-primary-menu .menu-item a');

if($(".navbar-toggler").is(":visible") == true){
    primaryMenuItem.each(function(){
        $(this).on('click', function(){
            $('.navbar-toggler').trigger('click');
        });
    });
}

// Add active class dynamically on menu item navigation when scrolling or navigating to the page
function updateMenuClass(){
    let menus = document.querySelectorAll(".header__inner .menu-item a");
    
    for(let x = 0; x < menus.length; x++){
        menus[x].classList.remove('active');
    }

    for (const elem of document.querySelectorAll('.section__indicator')){
        var viewportOffset = elem.getBoundingClientRect();

        if(viewportOffset.top <= 100 && viewportOffset.bottom >= 0){
            var elemTop = elem.getAttribute('id');

            menus.forEach(function (item, index) {
                var menuItem = item.getAttribute('href');

                item.classList.remove("active");

                if( '#' + elemTop == menuItem){
                    item.classList.add("active");
                }
            });
        }
    };
}

updateMenuClass();

$(window).on('load', function() {
    updateMenuClass();

    document.addEventListener('scroll', function(){
        updateMenuClass();
    });
});